import axios from "axios";
import { API_BASE_URL } from "./api";

const api = axios.create({
  baseURL: API_BASE_URL,
});

const getAuthHeader = () => {
  const token = window.localStorage.getItem("grawish_admin_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const newsletterApi = {
  loginAdmin: async (payload) => {
    const response = await api.post("/auth/login", payload);
    return response.data;
  },
  getCurrentAdmin: async () => {
    const response = await api.get("/auth/me", {
      headers: getAuthHeader(),
    });
    return response.data;
  },
  getPublishedNewsletters: async (params = {}) => {
    const response = await api.get("/newsletters", { params });
    return response.data;
  },
  getPublishedBlogs: async (params = {}) => {
    const response = await api.get("/blogs", { params });
    return response.data;
  },
  getPublishedCaseStudies: async (params = {}) => {
    const response = await api.get("/case-studies", { params });
    return response.data;
  },
  getNewsletter: async (slug) => {
    const response = await api.get(`/newsletters/${slug}`);
    return response.data;
  },
  getBlog: async (slug) => {
    const response = await api.get(`/blogs/${slug}`);
    return response.data;
  },
  getCaseStudy: async (slug) => {
    const response = await api.get(`/case-studies/${slug}`);
    return response.data;
  },
  getAdminNewsletters: async () => {
    const response = await api.get("/newsletters/admin/all", {
      headers: getAuthHeader(),
    });
    return response.data;
  },
  getAdminBlogs: async () => {
    const response = await api.get("/blogs/admin/all", {
      headers: getAuthHeader(),
    });
    return response.data;
  },
  getAdminCaseStudies: async () => {
    const response = await api.get("/case-studies/admin/all", {
      headers: getAuthHeader(),
    });
    return response.data;
  },
  createNewsletter: async (payload) => {
    const response = await api.post("/newsletters/admin", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...getAuthHeader(),
      },
    });
    return response.data;
  },
  createBlog: async (payload) => {
    const response = await api.post("/blogs/admin", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...getAuthHeader(),
      },
    });
    return response.data;
  },
  createCaseStudy: async (payload) => {
    const response = await api.post("/case-studies/admin", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...getAuthHeader(),
      },
    });
    return response.data;
  },
  updateNewsletter: async (id, payload) => {
    const response = await api.put(`/newsletters/admin/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...getAuthHeader(),
      },
    });
    return response.data;
  },
  updateBlog: async (id, payload) => {
    const response = await api.put(`/blogs/admin/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...getAuthHeader(),
      },
    });
    return response.data;
  },
  updateCaseStudy: async (id, payload) => {
    const response = await api.put(`/case-studies/admin/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...getAuthHeader(),
      },
    });
    return response.data;
  },
  deleteNewsletter: async (id) => {
    const response = await api.delete(`/newsletters/admin/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },
  deleteBlog: async (id) => {
    const response = await api.delete(`/blogs/admin/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },
  deleteCaseStudy: async (id) => {
    const response = await api.delete(`/case-studies/admin/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },
  subscribe: async (payload) => {
    const response = await api.post("/subscribers", payload);
    return response.data;
  },
  getSubscribers: async () => {
    const response = await api.get("/subscribers/admin/all", {
      headers: getAuthHeader(),
    });
    return response.data;
  },
  deleteSubscriber: async (id) => {
    const response = await api.delete(`/subscribers/admin/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },
};

export default api;
